import { UnifiedGraftModelTypeKey } from '@/core/const/unifiedGraftModelTypeKeys.const'
import type { FieldUsageTemplates } from '@/core/stores/code'
import type { ClassData, FieldData } from '@/core/types/library.type'
import { getInstanceVariableName } from '@/core/utils/getInstanceVariableName'

type BuildFieldSnippetParams = {
  classData: ClassData
  field: FieldData
  fieldUsageCode: FieldUsageTemplates
  instanceCode: string
  useConstructors: boolean
  technology?: string
}

export const buildFieldSnippet = ({
  classData,
  field,
  fieldUsageCode,
  instanceCode,
  useConstructors,
  technology,
}: BuildFieldSnippetParams): string => {
  const className = classData.name
  const instanceName = getInstanceVariableName(className, technology)

  if (field.type === UnifiedGraftModelTypeKey.GLOBAL_FIELD) {
    return fieldUsageCode.global.replaceAll('{field}', field.name)
  }

  if (field.isStatic || field.type === UnifiedGraftModelTypeKey.STATIC_FIELD) {
    return fieldUsageCode.static.replaceAll('{class}', className).replaceAll('{field}', field.name)
  }

  const usage = fieldUsageCode.instance.replaceAll('{name}', instanceName).replaceAll('{field}', field.name)

  if (useConstructors) {
    return usage
  }

  const instance = instanceCode
    .replaceAll('{class}', className)
    .replaceAll('{name}', instanceName)
    .replaceAll('{params}', '')

  if (!instance) {
    return usage
  }

  return `${instance}\n${usage}`
}
